import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { initGA, logPageView } from './analytics';
import ScrollToTopOnNavigate from './utils/ScrollToTopOnNavigate';
import NavBarHome from './Layouts/NavBarHome';

import HomePage from './Pages/HomePage';
import LegalPage from './Pages/LegalPage';
import RegistrationPage from './Pages/RegistrationPage';
import DemoPage from './Pages/DemoPage';
import BoCoCard from './Pages/Cards/BoCoCard';
import BernyCard from './Pages/Cards/BernyCard';
import AiPage from './Pages/AiPage';
import AnalysePage from './Pages/AnalysePage';
import DevelopPage from './Pages/DevelopPage';
import FollowPage from './Pages/FollowPage';
import FrameworkPage from './Pages/FrameworkPage';
import PrivacyPage from './Pages/PrivacyPage';
import CaseStudiesPage from './Pages/CaseStudiesPage';
import NetworkPage from './Pages/NetworkPage';
import LibraryPage from './Pages/LibraryPage';
import WhyPage from './Pages/WhyPage';
import WhoPage from './Pages/WhoPage';
import CareersPage from './Pages/CareersPage';
import PricingPage from './Pages/PricingPage';
import GrowPage from './Pages/GrowPage';

// Tracks route changes for analytics
const RouteChangeTracker = () => {
  const location = useLocation();
  useEffect(() => {
    logPageView(location.pathname);
  }, [location]);
  return null;
};

function App() {
  // Initialize Google Analytics once
  useEffect(() => {
    initGA();
  }, []);

  return (
    <>
      {/* Analytics tracking */}
      <RouteChangeTracker />
      {/* Global scroll restoration */}
      <ScrollToTopOnNavigate />
      {/* Navigation bar */}
      <NavBarHome />

      {/* Application routes */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/legal" element={<LegalPage />} />
        <Route path="/register" element={<RegistrationPage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/FrancescBoCo" element={<BoCoCard />} />
        <Route path="/BernatClSa" element={<BernyCard />} />
        <Route path="/ai" element={<AiPage />} />
        <Route path="/analyze" element={<AnalysePage />} />
        <Route path="/develop" element={<DevelopPage />} />
        <Route path="/follow" element={<FollowPage />} />
        <Route path="/framework" element={<FrameworkPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/case-studies" element={<CaseStudiesPage />} />
        <Route path="/network" element={<NetworkPage />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/why" element={<WhyPage />} />
        <Route path="/who" element={<WhoPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/grow" element={<GrowPage />} />
      </Routes>
    </>
  );
}

export default App;
